module.exports = __webpack_public_path__ + "img/customerLogo9.54beac2b.png";